// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"294":"aa90e944","491":"1ca8c72c"}[chunkId] + ".js";
};